import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';

import { company } from '~/company/Company';
import { CatalogCategory } from '~/stores/CategoriesStore';

import styles from './Chips.module.scss';

const Chips = ({
  category,
  className,
  wrap,
  isLoading,
}: {
  category: CatalogCategory;
  className?: string;
  wrap?: boolean;
  isLoading?: boolean;
}) => {
  if (isLoading) {
    return (
      <div className={classes([styles.root, wrap && styles.wrap, className])}>
        <div className={styles.inner}>
          <Skeleton containerClassName={styles.skeleton} />
          <Skeleton containerClassName={styles.skeleton} />
          <Skeleton containerClassName={styles.skeleton} />
        </div>
      </div>
    );
  }
  if (!category.types.length) {
    return null;
  }
  return (
    <div
      className={classes([
        styles.root,
        wrap && styles.wrap,
        company.isMarketplaceVariant && styles.marketplace,
        className,
      ])}
    >
      <div className={styles.inner}>
        {category.types.map(({ label, value }) => (
          <Link
            key={value}
            state={{ parent: category.data?.id }}
            to={`/c/${value}`}
            className={styles.chip}
          >
            {label}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default observer(Chips);
